import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { IAdminData, IApplicationContext } from './types';

export class GlobalApplicationContext implements IApplicationContext {
	constructor(protected apiConfigs?: any) {}

	getApiConfig() {
		return this.apiConfigs;
	}

	handleError(response: any) {
		if (response) {
			const status = response.status;
			const message = response.data.message;

			const handleErrorByStatus: { [key: number]: Function } = {
				400: () => this.notifyError(message, 'BACK_MESSAGE'),
				404: () => this.notifyError('Sorry item not found', 'NOT_FOUND'),
				429: () => this.notifyError(message, 'TOO_MANY_REQUESTS'),
				403: () =>
					this.notifyError(
						'Sorry you are not allowed to access this content',
						'FORBIDDEN',
					),
				401: () => null,
			};

			const errorHandler: any = handleErrorByStatus[status];
			if (errorHandler) return errorHandler();
		}
		this.notifyError(
			'Sorry, Unexpected error happened, please refresh your page and try again!',
		);
	}

	notifyError(content: string, id = 'UNEXPECTED_ERROR', duration = 3000) {
		toast(content, {
			type: 'error',
			toastId: id,
			autoClose: 3000,
		});
	}

	handleInfo(response: any) {
		console.error('ApplicationContext::handleInfo', response);
	}

	getDeviceDataAsString(): string {
		let deviceId: any = localStorage.getItem('deviceId');
		if (!deviceId) {
			deviceId = uuidv4();
			localStorage.setItem('deviceId', deviceId);
		}
		return `{"deviceId":"${deviceId}","platform":"WEB"}`;
	}

	getCurrentLanguage() {
		return 'en';
	}

	getAttributeLanguage(value: any): string {
		return value
			? value[this.getCurrentLanguage()] || value.en || value
			: value;
	}

	setAuthToken(newToken: string): string | null {
		localStorage.setItem('authToken', `Bearer ${newToken}`);
		return this.authToken;
	}

	setRefreshToken(token: string): string | null {
		localStorage.setItem('refreshToken', token);
		return this.refreshToken;
	}

	setAdminUserData(data: IAdminData | null) {
		if (data) {
			localStorage.setItem('adminUserData', JSON.stringify(data));
			return;
		}
		localStorage.removeItem('adminUserData');
	}

	clearAutheticatedAdminUserData() {
		localStorage.removeItem('authToken');
		localStorage.removeItem('refreshToken');
		localStorage.removeItem('adminUserData');
	}

	stripHtml(html: string): string {
		const tmp = document.createElement('DIV');
		tmp.innerHTML = html;
		return tmp.textContent || tmp.innerText || '';
	}

	get authToken(): string | null {
		return localStorage.getItem('authToken');
	}

	get refreshToken(): string | null {
		return localStorage.getItem('refreshToken');
	}

	get adminUserData(): IAdminData | null {
		const data = localStorage.getItem('adminUserData');
		if (!data) return null;
		try {
			return JSON.parse(data);
		} catch (e) {
			return null;
		}
	}
}

export default GlobalApplicationContext;
